import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RolloutState, RolloutUserType } from "@utils/rollout";

export interface PersistentBrowserFlagsState {
  featureRolloutTypes: Record<string, RolloutState>;
}

interface SetFeatureRolloutTypePayload {
  feature: string;
  rolloutType: RolloutUserType;
}

// Persistent flags for device-level storage
const initialState: PersistentBrowserFlagsState = {
  featureRolloutTypes: {},
};

const persistentBrowserFlagsSlice = createSlice({
  name: "persistentBrowserFlags",
  initialState,
  reducers: {
    setFeatureRolloutType(
      state,
      action: PayloadAction<SetFeatureRolloutTypePayload>
    ) {
      const { feature, rolloutType } = action.payload;
      return {
        ...state,
        featureRolloutTypes: {
          ...state.featureRolloutTypes,
          [feature]: { rolloutType },
        },
      };
    },
  },
});

export const { setFeatureRolloutType } = persistentBrowserFlagsSlice.actions;

export default persistentBrowserFlagsSlice;
